import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ProcessReqFieldModel, ProcessStepModel } from '../../process.model';
import { select, Store } from '@ngrx/store';
import { selectStepById } from '../../selectors/process.selectors';
import { AppState } from '../../../../app.service';
import * as Defaults from '../../default-process-fields';
import { Subject, Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { FormControl } from '@angular/forms';
import { ModalService } from '../../../../lib/services/modal.service';
import { AddQuestionComponent } from '../../../../questions-module/components/add-question.component';
import { UpdateJobProcessStep } from '../../actions/process.actions';
import { ProcessQuestionModel } from '../../../../questions-module/models/questions.model';

@Component({
  selector: 'mj-process-application',
  templateUrl: './process-application.component.html',
  styleUrls: ['./process-application.component.scss'],
})
export class ProcessApplicationComponent implements OnInit, OnDestroy {
  @Output() processChanged = new EventEmitter();
  @Output() blurChanged = new EventEmitter<boolean>();
  @Input() stepId: number;

  defaults = Defaults;
  step: ProcessStepModel;
  questions: ProcessQuestionModel[];
  applicationMailChecked: boolean = true;
  message: FormControl;
  defaultMsg: string;
  @Input() stepOpenedUuid$: Subject<string>;
  isStepActive: boolean = true;
  private step$: Subscription;

  constructor(
    private store: Store<AppState>,
    private translate: TranslateService,
    private modalService: ModalService
  ) {
    this.translate
      .get('step_applied_message')
      .pipe(take(1))
      .subscribe(msg => {
        this.defaultMsg = msg;
        this.message = new FormControl(msg);
      });
  }

  ngOnInit() {
    this.step$ = this.store
      .pipe(select(selectStepById(this.stepId)))
      .subscribe(data => {
        if (data) {
          this.step = data;
          this.questions = JSON.parse(JSON.stringify(data.questions));
          // if (this.step && this.step.required_fields.length === 0) {
          //     this.processChanged.emit({
          //         id: this.stepId,
          //         changes: {required_fields: this.defaults.DefaultRequiredFields}
          //     });
          // }
          if (this.step.actions.length && !this.step.actions[0].message) {
            this.message.patchValue(this.defaultMsg);
            this.updateAction();
          }
          if (
            this.step.actions.length &&
            this.step.actions[0].message &&
            this.message.value !== this.step.actions[0].message
          ) {
            this.message.patchValue(this.step.actions[0].message);
          }
          if (data && data.actions.length === 0) {
            this.processChanged.emit({
              id: this.stepId,
              changes: {
                actions: [this.defaults.DefaultActions[0]],
              },
            });
          }
          if (
            this.step.actions.length &&
            this.applicationMailChecked !== this.step.actions[0].enabled
          ) {
            this.applicationMailChecked = this.step.actions[0].enabled;
          }
          // if (data.actions) {
          //     this.setDefaultMessage();
          // }
        }
      });

    this.stepOpenedUuid$.subscribe(uuid => {
      this.isStepActive = uuid === this.step.uuid;
    });
  }

  ngOnDestroy(): void {
    if (this.step$) {
      this.step$.unsubscribe();
    }
  }

  onReqFieldClicked(field: ProcessReqFieldModel) {
    const newField: ProcessReqFieldModel = {
      ...field,
    };
    newField.enabled = !newField.enabled;

    const reqFields = this.step.required_fields.map(
      (item: ProcessReqFieldModel) => {
        if (item.type !== newField.type) {
          return item;
        }
        return {
          ...item,
          ...newField,
        };
      }
    );

    this.processChanged.emit({
      id: this.stepId,
      changes: { required_fields: reqFields },
    });
  }

  onAddQuestionClicked() {
    this.blurChanged.emit(true);
    this.modalService
      .appendComponentToBody(AddQuestionComponent, Object.assign({}, this.step))
      .pipe(take(1))
      .subscribe(data => {
        if (data) {
          this.store.dispatch(
            new UpdateJobProcessStep({
              id: this.stepId,
              changes: {
                questions: data,
              },
            })
          );
        }
        this.blurChanged.emit(false);
      });
  }

  updateAction() {
    const newArr = this.step.actions.map(action => {
      return {
        ...action,
        enabled: this.applicationMailChecked,
        message: this.message.value,
      };
    });
    this.processChanged.emit({
      id: this.stepId,
      changes: { actions: newArr },
    });
  }
}
